<template>
  <!-- ▼SideMenu Container -->
  <div
    :class="{ 'is-opened': isOpened, 'boss-menu-close': !expandsSidebar }"
    class="boss-admin-sidemenu-container"
    data-test="expand"
  >
    <div
      class="boss-admin-sidemenu-toggle"
      @click="toggle()"
    >
      <div class="boss-admin-sidemenu-toggle-bar" />
      <div class="boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-2" />
      <div class="boss-admin-sidemenu-toggle-bar boss-admin-sidemenu-toggle-bar-3" />
    </div>
    <div class="boss-admin-sidemenu-wrap">
      <nav class="boss-admin-sidemenu">
        <ul
          id="boss-dropdown-control"
          class="vertical dropdown menu boss-admin-sidemenu-list"
          data-dropdown-menu
        >
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{ 'boss-active': $route.path.includes('/dashboard') }"
              :to="{ name: 'dashboardTop' }"
              data-test="dashboard-top"
              class="boss-admin-sidemenu-link"
              exact-active-class="boss-active"
            >
              <div class="boss-menu-icon boss-menu-icon-dash">
                <!-- ▼icon dashboard -->
                <span class="boss-icon boss-icon-dashboard" />
                <!-- ▲icon dashboard -->
              </div>
              <div class="boss-menu-name">
                ダッシュボード
              </div>
            </router-link>
          </li>
          <li
            v-if="showScout"
            data-test="scout-sidemenu-link"
            class="boss-admin-sidemenu-item"
          >
            <router-link
              :class="{ 'boss-active': $route.path.includes('/scouts') }"
              :to="{ name: 'scoutTop' }"
              class="boss-admin-sidemenu-link"
              exact-active-class="boss-active"
              data-test="scout-and-liked"
            >
              <div class="boss-menu-icon boss-menu-icon-scoutandlike">
                <!-- ▼icon スカウト&いいね -->
                <span class="boss-icon boss-icon-scoutandlike" />
                <!-- ▲icon スカウト&いいね -->
              </div>
              <div class="boss-menu-name">
                スカウト&amp;いいね
              </div>
            </router-link>
          </li>
          <li
            v-if="showEntry"
            data-test="applicant-sidemenu-link"
            class="boss-admin-sidemenu-item"
          >
            <router-link
              :class="{ 'boss-active': $route.path.includes('/applicants') }"
              :to="{ name: 'applicantTop' }"
              data-test="applicant-top"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-apply">
                <!-- ▼icon 応募者管理 -->
                <span class="boss-icon boss-icon-apply" />
                <!-- ▲icon 応募者管理 -->
              </div>
              <div class="boss-menu-name">
                応募者管理
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <span
              :class="{'boss-active': $route.path.includes('/preview')}"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-posting">
                <!-- ▼icon 掲載中の求人原稿 -->
                <span class="boss-icon boss-icon-posting" />
                <!-- ▲icon 掲載中の求人原稿 -->
              </div>
              <div class="boss-menu-name">求人確認<span class="boss-icon-triangle" /></div>
            </span>
            <ul class="vertical menu nested boss-side-submenu">
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'previewJobEditTop' }"
                  data-test="preview-job-edit-top"
                  class="boss-submenu-link"
                >
                  掲載前の求人
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'previewJobConfirmTop' }"
                  data-test="preview-job-confirm-top"
                  class="boss-submenu-link"
                >
                  掲載済みの求人・応募フォームタイプ設定
                </router-link>
              </li>
            </ul>
          </li>
          <li class="boss-admin-sidemenu-item">
            <router-link
              :class="{ 'boss-active': $route.path.includes('/interviews') }"
              :to="{ name: 'interviewTop' }"
              data-test="interview"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-interview">
                <!-- ▼面接情報 -->
                <span class="boss-icon boss-icon-interview" />
                <!-- ▲面接情報 -->
              </div>
              <div class="boss-menu-name">
                面接情報
              </div>
            </router-link>
          </li>
          <li class="boss-admin-sidemenu-item">
            <span
              :class="{'boss-active': $route.path.includes('/settings')}"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-setting">
                <!-- ▼icon 各種設定 -->
                <span class="boss-icon boss-icon-setting" />
                <!-- ▲icon 各種設定 -->
              </div>
              <div class="boss-menu-name">各種設定<span class="boss-icon-triangle" /></div>
            </span>
            <ul class="vertical menu nested boss-side-submenu">
              <li
                v-if="showAccounts"
                data-test="account-sidemenu-link"
                class="boss-side-submenu-item"
              >
                <router-link
                  :to="{ name: 'settingAccounts' }"
                  data-test="setting-accounts"
                  class="boss-submenu-link"
                >
                  アカウント管理
                </router-link>
              </li>
              <li
                v-if="showAllowedIpAddress"
                data-test="ip-address-sidemenu-link"
                class="boss-side-submenu-item"
              >
                <router-link
                  :to="{ name: 'settingIpAddress' }"
                  data-test="ip-address"
                  class="boss-submenu-link"
                >
                  閲覧制限用IPアドレス設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingScoutTemplates' }"
                  data-test="scout-template"
                  class="boss-submenu-link"
                >
                  スカウト＿テンプレート設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingMemberAttributes' }"
                  data-test="member-attributes"
                  class="boss-submenu-link"
                >
                  スカウト・いいね＿一覧画面の表示情報の設定
                </router-link>
              </li>
              <li
                v-if="showScout"
                class="boss-side-submenu-item"
                data-test="auto-liked-settings-sidemenu-link"
              >
                <router-link
                  :to="{ name: 'settingAutoLikedTop' }"
                  data-test="auto-liked-settings"
                  class="boss-submenu-link"
                >
                  いいね自動送信設定
                </router-link>
              </li>
              <li
                v-if="showSettingsSelection"
                class="boss-side-submenu-item"
                data-test="selection-sidemenu-link"
              >
                <router-link
                  :to="{ name: 'settingSelections' }"
                  data-test="screening-process"
                  class="boss-submenu-link"
                >
                  応募者管理＿選考フェーズ・ステータス設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingMessageTemplates' }"
                  data-test="message-templates"
                  class="boss-submenu-link"
                >
                  応募者管理＿テンプレート設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingApplicantColumns' }"
                  data-test="applicant-columns"
                  class="boss-submenu-link"
                >
                  応募者管理＿一覧画面の表示情報の設定
                </router-link>
              </li>
              <li class="boss-side-submenu-item">
                <router-link
                  :to="{ name: 'settingApplicantAutoReplySelection' }"
                  data-test="auto-message"
                  class="boss-submenu-link"
                >
                  応募者管理＿自動受付メッセージ設定
                </router-link>
              </li>
            </ul>
          </li>
          <li class="boss-admin-sidemenu-item">
            <a
              target="_blank"
              data-test="user-help"
              href="/help/index.html"
              class="boss-admin-sidemenu-link"
            >
              <div class="boss-menu-icon boss-menu-icon-apply">
                <!-- ▼icon ユーザーガイド -->
                <span class="boss-icon boss-icon-question" />
                <!-- ▲icon ユーザーガイド -->
              </div>
              <div class="boss-menu-name">ユーザーガイド</div>
            </a>
          </li>
        </ul>
      </nav>
      <div class="pega-sidemenu-line" />
      <div
        v-if="showDtypeEntryLink"
        v-tooltip="{ content: isNewDtypeEntry ? 'Direct type経由で応募・メッセージが届いています。<br>ご確認ください。' : '', html: 'true', skidding: tooltipSkidding, arrowPadding: tooltipArrowPadding }"
        data-test="dtype-link"
        class="pega-dtype-menu"
        :class="{ 'boss-new': isNewDtypeEntry }"
      >
        <a
          target="_blank"
          data-test="dtype-url"
          :href="dtypeEntryUrl"
          class="boss-admin-sidemenu-link pega-dtype-link"
        >
          <div class="pega-dtype-menu-container">
            <div class="boss-menu-icon boss-menu-icon-apply">
              <span class="boss-icon boss-icon-dtype" />
            </div>
            <div class="boss-menu-name pega-dtype-menu-name">
              <span class="pega-dtype-menu-name-first">Direct type</span>
              <span class="pega-dtype-menu-name-second">応募者管理 画面</span>
              <span class="pega-dtype-menu-name-third">（別タブ表示）</span>
            </div>
          </div>
        </a>
      </div>
      <a
        class="boss-admin-sidemenu-openandclose"
        data-test="menu-open-and-close"
        @click="menuOpenClose"
      >
        <div class="boss-admin-sidemenu-link">
          <div class="boss-menu-icon boss-menu-icon-open">
            <!-- ▼icon メニュー開閉 -->
            <span class="boss-icon boss-icon-close" />
            <!-- ▲icon メニュー開閉 -->
          </div>
          <div class="boss-menu-name">メニューを閉じる</div>
        </div>
      </a>
      <div
        v-show="expandsSidebar"
        data-test="information-second"
        v-html="informationSecond"
      />
    </div>
  </div>
  <!-- ▲SideMenu Container -->
</template>

<script>
import Foundation from 'foundation-sites'
import jQuery from 'jquery'
import { mapGetters, mapActions } from 'vuex'

const DTYPE_URL = process.env.DTYPE_DCS_ENDPOINT
export default {
  data () {
    return {
      isOpened: false,
      isNewDtypeEntry: false,
      informationSecond: ''
    }
  },
  computed: {
    ...mapGetters([
      'showScout',
      'showAccounts',
      'showEntry',
      'showAllowedIpAddress',
      'showSettingsSelection',
      'showDtypeEntryLink',
      'expandsSidebar'
    ]),
    dtypeEntryUrl: () => DTYPE_URL + '/entries',
    tooltipArrowPadding () {
      return this.expandsSidebar ? 129 : 9 // サイドバーの開閉状況でpaddingを変更
    },
    tooltipSkidding () {
      return this.expandsSidebar ? 100 : 165 // サイドバーの開閉状況でskiddingを変更
    }
  },
  watch: {
    $route: {
      handler () {
        this.showDtypeEntryLink && this.fetchDtypeEntryIsNew()
      }
    }
  },
  async created () {
    await this.$store.dispatch('setIsEnabledDtype')
    this.fetchContentsInformationSecond()
    this.showDtypeEntryLink && this.fetchDtypeEntryIsNew()
  },
  mounted () {
    this.Sidebar = new Foundation.DropdownMenu(jQuery('#boss-dropdown-control'), {
      // These options can be declarative using the data attributes
      hoverDelay: 200
    })
  },
  destroyed () {
    this.Sidebar.destroy()
  },
  methods: {
    menuOpenClose () {
      this.toggleExpandsSidebar()
    },
    toggle () {
      this.isOpened = !this.isOpened
    },
    ...mapActions([
      'toggleExpandsSidebar'
    ]),
    fetchContentsInformationSecond () {
      this.$http.secured.get('/company/contents/bko_information_second').then((response) => {
        this.$set(this, 'informationSecond', response.data)
      })
    },
    fetchDtypeEntryIsNew () {
      this.$http.secured.get('/dtype/entry/is_new').then((response) => {
        this.$set(this, 'isNewDtypeEntry', response.data)
      })
    }
  }
}
</script>
